
        <div class="c-wo-dialog" #woDialogEl [ngStyle]="dialog?.options?.css">
            <div class="c-wo-dialog__content">
                <a href="javascript:void(0);" class="c-wo-dialog__close-btn" (click)="close()">×</a>
                <ng-template appWoDialogHost></ng-template>
            </div>
        </div>
    